import { render, staticRenderFns } from "./DataReportMailing.vue?vue&type=template&id=1a7a168e"
import script from "./DataReportMailing.vue?vue&type=script&lang=js"
export * from "./DataReportMailing.vue?vue&type=script&lang=js"
import style0 from "./DataReportMailing.vue?vue&type=style&index=0&id=1a7a168e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports